var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound84CSelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#C1A36E",
  strokeWidth: 2,
  d: "M41 30.002c0 6.075-4.925 11-11 11-6.076 0-11-4.925-11-11s4.924-11 11-11c6.075 0 11 4.925 11 11Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M4 6.5V35l7.251.725A2.5 2.5 0 0 0 14 33.237V16.5a2.5 2.5 0 0 1 2.5-2.5h27a2.5 2.5 0 0 1 2.5 2.5v16.737a2.5 2.5 0 0 0 2.749 2.488L56 35V6.5A2.5 2.5 0 0 0 53.5 4h-47A2.5 2.5 0 0 0 4 6.5Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M56 36V6.5A2.5 2.5 0 0 0 53.5 4h-47A2.5 2.5 0 0 0 4 6.5V36"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m47.758 50.758-8.66 5-4.788-6.789a2.5 2.5 0 0 1 .793-3.606l5.65-3.262a2.5 2.5 0 0 1 3.52 1.116l3.485 7.541Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m47.624 48.526.03.497a2.812 2.812 0 0 1-1.4 2.604l-5.65 3.262a2.813 2.813 0 0 1-2.956-.088l-.416-.275"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "m12.242 50.758 8.66 5 4.788-6.789a2.5 2.5 0 0 0-.793-3.606l-5.65-3.262a2.5 2.5 0 0 0-3.52 1.116l-3.486 7.541Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#C1A36E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m12.376 48.526-.03.497a2.812 2.812 0 0 0 1.4 2.604l5.65 3.262a2.813 2.813 0 0 0 2.956-.088l.416-.275"
})));
SvgRound84CSelected.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound84CSelected);
export default ForwardRef;